import { ref } from "vue";
import Config from "@/const/Config";

/*
* 雇用契約書を印刷する（ダウンロードする）
*/
export function usePrint() {

  const downLoad = (id: number): string => {

    return Config.API_URL + "/koyoukeiyaku/print/" + id;
  }

  return {
    downLoad,
  }

}


